<template>
  <v-container fluid>
    <v-form
      :class="'f_' + size"
      v-model="valid"
      v-if="treeview || (treeview && dropdown)"
      :ref="'formCatalogue_' + _uid"
    >
      <v-autocomplete
        open-on-clear
        :search-input.sync="search"
        class="edn-catalogue-autocomplete"
        attach
        :rules="getRules"
        :ref="'SelectedTreeview' + _uid"
        :placeholder="placeholder"
        persistent-placeholder
        v-click-outside="onClickOutside"
        :filled="getIrisRdonlyMode"
        :disabled="getIrisRdonlyMode"
        :menu-props="menuProps"
        v-model="fakeModel"
        :items="fakeItems"
        chips
        :label="label"
        item-text="name"
        item-value="id"
        multiple
        :clearable="getClearableTree"
        @keydown.delete="noBackspace"
        @click="getOpen"
        @click:clear="clearValueTree"
      >
        <template v-slot:label>
          <span :title="label" class="edn-truncated--text">{{ label }} </span
          ><span v-if="required && required != false && !getIrisRdonlyMode" class="mx-1 red--text">*</span>
          <edn-tooltip :iconSize="22" :color="success ? 'success' : ''" v-if="tooltip"> {{ tooltip }}</edn-tooltip>
        </template>

        <template v-slot:selection>
          <template v-for="(itemID, index) in getItems">
            <v-chip
              label
              :key="'chip' + index"
              :close="deletableChips"
              @click:close="remove(index, itemID)"
              v-if="index <= 1"
              :small="getIrisMode"
              :text-color="getIrisChipTxtColor"
              :color="getIrisChipColor"
            >
              <!-- {{getItems[index].name}} -->
              {{ getSelectedValues(items, itemID).name }}
            </v-chip>
            <span :key="'chip' + index" v-if="index === 2" class="grey--text text-caption">
              (+{{ activeItem.length - 2 }} others)
            </span>
          </template>
        </template>
        <template v-slot:prepend-item>
          <v-treeview
            return-object
            :search="search"
            :filter="filter"
            @input="setLabelNoData($event)"
            open-on-click
            :activatable="!isMultiple"
            :selectable="isMultiple"
            :active.sync="active"
            v-model="activeItem"
            :items="items"
            :selected-color="colors.primary"
            :selection-type="selectionType"
            item-disabled="Disabled"
          >
            <template v-slot:prepend="{ item }">
              <v-icon v-if="item.icon">
                {{ item.icon }}
              </v-icon>
            </template>
          </v-treeview>
        </template>
        <template v-slot:append v-if="getIrisRdonlyMode">
          <v-icon class="v-icon--disabled">mdi-menu-down</v-icon>
          <v-icon class="v-icon--disabled">mdi-lock</v-icon>
        </template>
        <template v-slot:append-outer v-if="actionOuter">
          <v-icon @click="callBack(selection, 'click-outer', mru)">{{
            actionOuter == true ? 'mdi-open-in-new' : actionOuter
          }}</v-icon>
        </template>
      </v-autocomplete>
    </v-form>

    <v-form
      :class="!dropdown ? 'dropdownOff' : 'dropdownOn'"
      v-model="valid"
      v-if="!treeview"
      :ref="'formCatalogue_' + _uid"
    >
      <v-autocomplete
        :menu-props="menuProps"
        :hide-no-data="!dropdown"
        :success="success"
        :search-input.sync="search"
        class="edn-catalogue-autocomplete"
        attach
        :clearable="!required && !success"
        :rules="getRules"
        v-model="listLocal"
        :disabled="getIrisRdonlyMode"
        :items="dropdown ? datas : items"
        :ref="'SelectedTreeview' + _uid"
        v-click-outside="onClickOutside"
        :filled="getIrisRdonlyMode"
        chips
        :label="label"
        item-text="name"
        item-value="id"
        :multiple="multiple"
        return-object
        :placeholder="placeholder"
        persistent-placeholder
        :deletable-chips="deletableChips"
        @change="setChange"
        @focus="setIndex"
        @keydown.delete="noBackspace"
        @input="setInput()"
        @click:clear="clearValue"
        eager
      >
        <template v-slot:label>
          <span :title="label" class="edn-truncated--text">{{ label }} </span>
          <span v-if="required && required != false && !getIrisRdonlyMode" class="mx-1 red--text">*</span>
          <edn-tooltip :iconSize="22" :color="success ? 'success' : ''" v-if="tooltip"> {{ tooltip }}</edn-tooltip>
        </template>
        <template v-slot:selection="{ item, index }">
          <v-tooltip bottom v-if="item.tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                :text-color="pickTextColorBasedOnBgColorAdvanced(item.color)"
                v-bind="attrs"
                v-on="on"
                :color="item.color"
                label
                :close="deletableChips"
                @click:close="remove(index)"
                v-if="index <= 1"
              >
                <span>{{ item.name }}</span>
              </v-chip>
            </template>
            <span>{{ item.tooltip }}</span>
          </v-tooltip>
          <v-chip
            v-if="index <= 1 && !item.tooltip"
            :text-color="pickTextColorBasedOnBgColorAdvanced(item.color)"
            :color="item.color"
            label
            :close="deletableChips"
            @click:close="remove(index)"
          >
            <span>{{ item.name }}</span>
          </v-chip>
          <span v-if="index === 2" class="grey--text text-caption"> (+{{ listLocal.length - 2 }} others) </span>
        </template>
        <!--
        <template v-if="(firstTopMru || secondTopMru || listButtonClear) && dropdown" v-slot:prepend-item>
          <template>
            <div class="top-sticked">
              <v-list-item @click="clearValueFromList" dense link v-if="getListButtonClear">
                <v-list-item-content>
                  <v-list-item-title> Non renseigné </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="callBack(selection, 'action-first-top-dropdown', mru)" dense link v-if="firstTopMru">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon v-if="firstTopMru.icon" class="mr-1" size="20">{{ firstTopMru.icon }}</v-icon>
                    {{ firstTopMru.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="callBack(selection, 'action-second-top-dropdown', mru)"
                dense
                link
                v-if="secondTopMru"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon v-if="secondTopMru.icon" class="mr-1" size="20">{{ secondTopMru.icon }}</v-icon>
                    {{ secondTopMru.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
            </div>
          </template>
        </template>
         -->
        <template v-if="dropdown" v-slot:item="{ item, on, attrs }">
          <v-list-item
            dense
            :class="item.visible === false || item.disabled === true ? 'item-hidden' : ''"
            v-bind="attrs"
            v-on="on"
          >
            <v-list-item-content>
              <v-tooltip v-if="item.tooltip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title v-bind="attrs" v-on="on">
                    <v-icon v-if="item.icon" class="mr-2">{{ item.icon }}</v-icon>
                    {{ item.name }}
                  </v-list-item-title>
                </template>
                <span>{{ item.tooltip }}</span>
              </v-tooltip>
              <v-list-item-title v-else>
                <v-icon v-if="item.icon" class="mr-2">{{ item.icon }}</v-icon>
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <!--
        <template
          v-if="(firstBottomMru || secondBottomMru || listButtonLoadAll || listButtonShowModal) && dropdown"
          v-slot:append-item
        >
          <template>
            <div class="bottom-sticked">
              <v-divider />

              <v-list-item @click="showAllDataFromList" link dense v-if="listButtonLoadAll">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon class="mr-1" size="20">mdi-playlist-plus</v-icon>
                    Charger toutes les valeurs
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="showModal" link dense v-if="listButtonShowModal">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon class="mr-1" size="20">mdi-magnify</v-icon>
                    Sélection avancée
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                @click="callBack(selection, 'action-first-bottom-dropdown', mru)"
                link
                dense
                v-if="firstBottomMru"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon v-if="firstBottomMru.icon" class="mr-1" size="20">{{ firstBottomMru.icon }}</v-icon>
                    {{ firstBottomMru.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="callBack(selection, 'action-second-bottom-dropdown', mru)"
                link
                dense
                v-if="secondBottomMru"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon v-if="secondBottomMru.icon" class="mr-1" size="20">{{ secondBottomMru.icon }}</v-icon>
                    {{ secondBottomMru.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </template>
        </template>
        -->
        <template v-slot:append v-if="getIrisRdonlyMode || success">
          <v-icon :color="success ? 'success' : ''"
            >{{ success ? 'mdi-check' : !getIrisRdonlyMode ? 'mdi-menu-down' : '' }}
          </v-icon>
          <v-icon class="v-icon--disabled">{{ getIrisRdonlyMode ? 'mdi-lock' : '' }}</v-icon>
        </template>
        <template v-slot:append-outer v-if="actionOuter">
          <v-icon @click="callBack(selection, 'click-outer', mru)">{{
            actionOuter == true ? 'mdi-open-in-new' : actionOuter
          }}</v-icon>
        </template>
      </v-autocomplete>

      <edn-modal
        :close="closeModal"
        :maximize="maximizeModal"
        :title="'Catalogue: ' + label"
        v-model="modal"
        :fullscreen="fullscreen"
        ><!--
        <template v-slot:modal-content>
          <v-card class="mx-auto" max-width="500">
            <v-container class="py-0">
              <v-row align="center" justify="start">
                <v-col v-for="(selection, i) in selections" :key="selection.name" class="shrink">
                  <v-chip :disabled="loading" close @click:close="selected.splice(i, 1)">
                    <v-icon left v-text="selection.icon"></v-icon>
                    {{ selection.name }}
                  </v-chip>
                </v-col>

                <v-col v-if="!allSelected" cols="12">
                  <v-text-field
                    ref="searchComponent"
                    v-model="searchComponent"
                    full-width
                    hide-details
                    label="searchComponent"
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <v-divider v-if="!allSelected"></v-divider>
            <v-list>
              <template v-for="item in categories">
                <v-list-item
                  v-if="!selected.includes(item)"
                  :key="item.name"
                  :disabled="loading"
                  @click="selected.push(item)"
                >
                  <v-list-item-avatar>
                    <v-icon :disabled="loading" v-text="item.icon"></v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!selected.length" :loading="loading" color="purple" text @click="next"> Next </v-btn>
            </v-card-actions>
          </v-card>
        </template>

        -->
        <template v-slot:modal-content>
          <v-card-title class="pa-0">
            <div class="pa-4 pt-6 search-modal-catalogue">
              <v-text-field
                dense
                hide-details
                persistent-placeholder
                ref="searchComponent"
                v-model="searchComponent"
                placeholder="Rechercher une valeur dans la liste"
                label="Recherche"
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
            </div>
            <div class="action-btn-modale">
              <v-btn v-if="actionButtons.addButton" small class="mr-5">Ajouter</v-btn>
              <v-btn v-if="actionButtons.exportButton" small class="mr-5">Exporter</v-btn>
              <v-btn v-if="actionButtons.importButton" small class="mr-5">Importer</v-btn>
            </div>
          </v-card-title>
          <div class="content-catalogue">
            <div class="content-catalogue-list" :class="!multiple ? 'content-catalogue-list-simple' : ''">
              <v-card tile class="elevation-0 pa-0 overflow-auto" height="100%">
                <v-card-text class="pa-0">
                  <v-list max-width="450.5px" class="pa-0 list-catalogue-content" dense flat>
                    <v-subheader class="pa-0 sticky-list sticky-list-top">
                      <v-list class="pa-0 list-catalogue" dense>
                        <v-list-item class="item-list">
                          <v-list-item-icon class="mr-2">
                            <v-icon></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <div class="item-content d-flex">
                                <span class="item-span item-name">Nom</span>
                                <span class="item-span">ID </span>
                                <span class="item-span">CODE</span>
                              </div>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-subheader>
                    <template v-for="item in itemsModale">
                      <v-list-item
                        :key="item.name"
                        :disabled="item.disabled"
                        class="item-list"
                        :class="item.visible === false || item.disabled === true ? 'item-hidden' : ''"
                        :value="item.id"
                        v-if="!selected.includes(item)"
                        @click="addSelections(item)"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon v-text="item.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-tooltip v-if="item.tooltip && item.tooltip != ''" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="item-content d-flex">
                                  <span class="item-span item-name">{{ item.name }} </span>
                                  <span class="item-span">{{ item.id }} </span>
                                  <span class="item-span">{{ item.code }}</span>
                                </div>
                              </template>
                              <span>{{ item.tooltip }}</span>
                            </v-tooltip>
                            <div v-else class="item-content d-flex">
                              <span class="item-span item-name">{{ item.name }} </span>
                              <span class="item-span">{{ item.id }} </span>
                              <span class="item-span">{{ item.code }}</span>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card-text>
              </v-card>
              <v-subheader v-if="multiple" class="pa-0 sticky-list sticky-list-bottom">
                <v-btn @click="pushAllItems()" tile class="btn-left elevation-0" width="calc(50% + 1px)" height="41"
                  >Tout sélectionner</v-btn
                >
                <v-btn @click="deleteAllItems()" tile class="btn-right elevation-0" width="50%" height="41"
                  >Tout désélectionner</v-btn
                >
              </v-subheader>
            </div>

            <div class="content-right">
              <v-card ref="contentRightTop" tile class="elevation-0 content-right-top"> </v-card>
              <v-card
                class="pt-0 px-3 elevation-0 right-panel-catalogue-modale pa-0 overflow-auto"
                :height="calcHeightRightPanel"
                width="100%"
                tile
              >
                <v-card-title class="font-weight-bold body-1 pl-1 pt-3 pb-2 pa-0 right-panel-selections-title">
                  {{ getTitleSelections }}
                </v-card-title>
                <v-card-text class="px-0 pt-0">
                  <v-row class="mx-0 mt-0 content-row-chips">
                    <template v-for="(selection, i) in selections">
                      <v-tooltip v-if="selection.tooltip && selection.tooltip != ''" bottom :key="selection.name">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            label
                            class="ma-1"
                            :text-color="pickTextColorBasedOnBgColorAdvanced(selection.color)"
                            :color="selection.color"
                            :key="selection.name"
                            close
                            @click:close="selected.splice(i, 1)"
                          >
                            {{ selection.name }}
                          </v-chip>
                        </template>
                        <span>{{ selection.tooltip }}</span>
                      </v-tooltip>
                      <v-chip
                        v-else
                        label
                        class="ma-1"
                        :text-color="pickTextColorBasedOnBgColorAdvanced(selection.color)"
                        :color="selection.color"
                        :key="selection.name"
                        close
                        @click:close="selected.splice(i, 1)"
                      >
                        {{ selection.name }}
                      </v-chip>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </template>

        <!--
        <template v-slot:modal-content>
          <v-card-title class="pa-0">
            <div class="pa-4 pt-6 search-modal-catalogue">
              <v-text-field
                dense
                hide-details
                persistent-placeholder
                placeholder="Rechercher une valeur dans la liste"
                label="Recherche"
                v-model="searchModal"
                clearable
                @click:clear="clearSearchModal"
              >
              </v-text-field>
            </div>
            <div class="action-btn-modale">
              <v-btn v-if="actionButtons.addButton" small class="mr-5">Ajouter</v-btn>
              <v-btn v-if="actionButtons.exportButton" small class="mr-5">Exporter</v-btn>
              <v-btn v-if="actionButtons.importButton" small class="mr-5">Importer</v-btn>
            </div>
          </v-card-title>
          <div class="content-catalogue">
            <v-card class="elevation-0 pa-0 overflow-auto" width="55%" height="100%">
              <v-card-text class="pa-0">
                <v-list max-width="450.5px" class="pa-0 list-catalogue-content" dense flat>
                  <v-subheader class="pa-0 sticky-list sticky-list-top">
                    <v-list class="pa-0 list-catalogue" dense>
                      <v-list-item class="item-list">
                        <v-list-item-icon class="mr-2">
                          <v-icon></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <div class="item-content d-flex">
                              <span class="item-span item-name">Nom</span>
                              <span class="item-span">ID </span>
                              <span class="item-span">CODE</span>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-subheader>
                  <v-list-item-group
                    active-class="proute"
                    :ref="'listItemGroup' + _uid"
                    :class="multiple ? 'list-item-group-multiple' : ''"
                    class="list-item-group-catalogue"
                    :multiple="multiple"
                    v-model="listSelection"
                    color="primary"
                  >
                    <template v-for="(item, i) in filteredItemsModal">
                      <v-tooltip :key="i" bottom v-if="item.tooltip && item.tooltip != ''">
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item
                            :disabled="item.disabled"
                            class="item-list"
                            :class="item.visible === false ? 'item-hidden' : ''"
                            v-bind="attrs"
                            v-on="on"
                            :key="i"
                            :value="item.id"
                            @click="setItemClicked"
                          >
                            <v-list-item-icon class="mr-2">
                              <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                <div class="item-content d-flex">
                                  <span class="item-span item-name">{{ item.name }} </span>
                                  <span class="item-span">{{ item.id }} </span>
                                  <span class="item-span">{{ item.code }}</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <span>{{ item.tooltip }}</span>
                      </v-tooltip>
                      <v-list-item
                        v-else
                        :disabled="item.disabled"
                        :class="item.visible === false ? 'item-hidden' : ''"
                        class="item-list"
                        :key="i"
                        :value="item.id"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon v-text="item.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <div class="item-content d-flex">
                              <span class="item-span item-name">{{ item.name }} </span>
                              <span class="item-span">{{ item.id }} </span>
                              <span class="item-span">{{ item.code }}</span>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                  <v-subheader v-if="multiple" class="pa-0 sticky-list sticky-list-bottom">
                    <v-btn tile class="btn-left elevation-0" width="50%" height="40">Tout sélectionner</v-btn>
                    <v-btn tile class="btn-right elevation-0" width="50%" height="40">Tout désélectionner</v-btn>
                  </v-subheader>
                </v-list>
              </v-card-text>
            </v-card>
            <v-card class="elevation-0 right-panel-catalogue-modale pa-0 overflow-auto" width="45%" height="100%">
              <v-card-text>
                <v-checkbox v-model="onlySelection" class="mt-0" color="primary" hide-details>
                  <template v-slot:label>
                    <div class="d-flex edn-label-check">
                      <div>Afficher les valeurs sélectionnées</div>
                    </div>
                  </template>
                </v-checkbox>
              </v-card-text>
            </v-card>
          </div>
        </template>
        -->
        <template v-slot:actions>
          <v-btn color="success" @click="validateModal"> Valider </v-btn>
        </template>
      </edn-modal>
      <div id="top-sticked" class="top-sticked" v-if="listButtonClear && dropdown">
        <v-list-item @click="clearValueFromList" dense link v-if="getListButtonClear">
          <v-list-item-content>
            <v-list-item-title> Non renseigné </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
      <div id="bottom-sticked" class="bottom-sticked" v-if="(listButtonLoadAll || listButtonShowModal) && dropdown">
        <v-divider />

        <v-list-item @click="showAllDataFromList" link dense v-if="listButtonLoadAll">
          <v-list-item-content>
            <v-list-item-title>
              <v-icon class="mr-1" size="20">mdi-playlist-plus</v-icon>
              Charger toutes les valeurs
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="showModal" link dense v-if="listButtonShowModal">
          <v-list-item-content>
            <v-list-item-title>
              <v-icon class="mr-1" size="20">mdi-magnify</v-icon>
              Sélection avancée
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { ednRegex } from './mixins/ednRegex'
import { ednRequired } from './mixins/ednRequired'
import { ednMimicMix } from './mixins/ednMimicMix'

import ednTooltip from './ednTooltip'
import ednModal from './ednModal'
//import _ from 'lodash'
export default {
  mixins: [ednRegex, ednRequired, ednMimicMix],
  components: {
    ednTooltip,
    ednModal,
  },
  props: {
    actionButtons: {
      type: Object,
      default: {
        addButton: false,
        exportButton: false,
        importButton: false,
      },
    },
    listButtonShowModal: {
      type: Boolean,
      default: false,
    },
    listButtonLoadAll: {
      type: Boolean,
      default: true,
    },
    listButtonClear: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'normal',
    },
    success: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: [Boolean, String],
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    selection: {
      type: [Array, Object],
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    dropdown: {
      type: Boolean,
      default: true,
    },
    treeview: {
      type: Boolean,
      default: false,
    },
    items: {
      type: [Array, Object],
      default: () => [],
    },
    actionOuter: {
      type: [Boolean, String],
      default: false,
    },
    firstBottomMru: {
      type: Object,
      default: () => {},
    },
    secondBottomMru: {
      type: Object,
      default: () => {},
    },
    firstTopMru: {
      type: Object,
      default: () => {},
    },
    secondTopMru: {
      type: Object,
      default: () => {},
    },
    errorMsg: {
      type: String,
      default: 'Champs obligatoire',
    },
  },
  data() {
    return {
      calcHeightRightPanel: 'calc(100% - 50)',
      searchComponent: '', // La valeur de recherche dans la modale
      selected: [], // les items sélectionnés

      localtest: [],
      onlySelection: false,
      removeValue: false,
      clearValueClick: false,
      focused: false,
      oldSearchModal: '',
      searchModal: '',
      modalListValue: [],
      closeModal: true, // Affiche le bouton de fermeture de la modale
      maximizeModal: true, // Affiche le bouton d'agrandissement de la modale
      fullscreen: false, // Ouvre la modale en plein écran ou non
      modal: false, // Ouvre la modale
      mru: [], // Les mru
      datas: [], // Permet de copier la props items
      valid: false, // Permet au v-form de valider le contenu
      search: null, // Le valeur de recherche dans le champs
      active: [], // Récupère les valeurs déjà sélectionnées
      activeItem: [], // Récupère les valeurs déjà sélectionnées
      colors: {
        //Définit les couleurs de vuetify
        primary: this.$vuetify.theme.currentTheme.primary,
        secondary: this.$vuetify.theme.currentTheme.secondary,
      },
      updateAfterClose: true, // Permet de savoir si la MAJ a été envoyer au composant parent
      selectionType: 'independent', // Le type de séléction, leaf ou independent (voir vuetify treeview)
      menuProps: {
        maxHeight: 329,
        // Permet de mettre le menu sous le select
        offsetY: true,
      },
      // Un fake Model est nécessaire pour customiser le select avec un treeview
      fakeModel: [
        {
          name: 'Eudonet',
          id: 0,
        },
      ],
      // Un fake Item est nécessaire pour customiser le select avec un treeview
      fakeItems: [
        {
          name: 'Eudonet',
          disabled: true,
          id: 0,
        },
      ],
    }
  },
  methods: {
    // Permet de charger les données en fonctions des options choisie
    getLoadItems() {
      if (this.dropdown) {
        if (this.$attrs.mru && !this.multiple && this.$attrs.mru.length > 0) {
          this.datas = this.$attrs.mru
        } else {
          this.datas = this.items
        }
      } else {
        this.$nextTick(() => {
          this.datas = this.items
        })
      }
    },
    // Permet de calculer la hauteur du conteneur des chips
    getCalcHeight() {
      this.$nextTick(() => {
        let height = this.$refs.contentRightTop.$el.offsetHeight
        this.calcHeightRightPanel = 'calc(100% - ' + height + 'px)'
      })
    },

    // Supprime tous les items selectionnée dans la modale
    deleteAllItems() {
      this.selected = []
    },

    // Ajoute tous les items
    pushAllItems() {
      this.items.forEach((item) => {
        let findItem = this.selected.find((a) => a.id == item.id)
        if (!findItem && !item.disabled && item.visible) {
          this.selected.push(item)
        }
      })
    },

    // Ajoute un item dans la sélection
    addSelections(item) {
      if (!this.multiple) {
        this.selected = []
      }
      this.$nextTick(() => {
        this.selected.push(item)
      })
    },

    // Permet de clear la recherche dans la modale
    clearSearchModal() {
      setTimeout(() => (this.searchModal = ''))
    },

    // Action au moment d'appuyer sur le bouton valider de la modale
    validateModal() {
      if (!this.multiple) {
        this.listLocal = this.selected[0]
        this.setMrus(this.selected[0])
      } else {
        this.listLocal = this.selected
      }
      this.modal = false
      this.$nextTick(() => {
        this.$refs['SelectedTreeview' + this._uid].blur()
        this.$refs['SelectedTreeview' + this._uid].isFocused = false
        this.focused = false
      })
    },

    // Ouvre la modal
    showModal() {
      this.selected = []
      if (!this.multiple) {
        if (!Array.isArray(this.listLocal)) {
          this.selected.push(this.listLocal)
        }
      } else {
        this.listLocal.forEach((item) => {
          this.selected.push(item)
        })
      }
      setTimeout(() => {
        if (!this.clearValueClick && !this.removeValue) {
          this.modal = true
        }
      }, 0)
    },

    // Permet d'ajouter cette valeurs dans les MRU et de les afficher
    setMrus(value) {
      if (!this.multiple && this.$attrs.mru && value != null && this.dropdown) {
        let findItem = this.mru.find((a) => a.id == value.id)
        if (!findItem) {
          if (this.mru.length > 6) {
            this.mru.pop()
          }
          this.mru.unshift(value)
        }
        this.datas = this.mru
      }
    },

    // Au changement d'une valeur, ajoute les MRUs
    setChange(value) {
      this.setMrus(value)
    },

    // Permet, au clique sur "Charger toutes les valeurs", d'afficher les 100 premières valeurs de datas (items)
    showAllDataFromList() {
      this.datas = this.items
      this.$refs['SelectedTreeview' + this._uid].lastItem = 100
    },

    // Permet, au clique sur "Non renseigné", de vider la selections
    clearValueFromList() {
      this.callBack([], 'clear-value-from-list', this.mru)
    },

    // Permet de changer la couleur du texte de la chips en fonction de son background
    pickTextColorBasedOnBgColorAdvanced(hexcolor) {
      let hex = hexcolor.charAt(0) === '#' ? hexcolor.substring(1, 7) : hexcolor

      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
      }

      if (hex.length !== 6) {
        throw new Error('Invalid HEX color.')
      }

      let r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16)

      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000' : '#fff'
    },

    // Permet en multiple d'éviter quand on clique sur un valeur que la scroll barre remonte tout en haut
    setIndex(e) {
      if (!this.dropdown && !this.focused) {
        this.showModal()
        this.focused = true
      }
      if (this.multiple) {
        this.$refs['SelectedTreeview' + this._uid].setMenuIndex(null)
      }

      this.$nextTick(() => {
        let menu__content = this.$refs['SelectedTreeview' + this._uid].$el.getElementsByClassName('v-menu__content')[0]
        let elemTop = document.getElementById('top-sticked')
        let elemBottom = document.getElementById('bottom-sticked')
        if (elemTop) menu__content.prepend(elemTop)
        if (elemBottom) menu__content.appendChild(elemBottom)
      })
    },

    // Permet d'envoyer au parent, les valeurs selectionnées, l'event sur le quel il a cliqué et les mru
    callBack(values, event) {
      this.$emit('callBack', values, event, this.mru)
    },

    // Permet au momment de selectioner une valeur, quand il est multiple, de garder la recherche active avec la valeur de recherche
    // Si il n'est pas multiple, on ferme le menu et on remet la valeur this.search à null
    setInput(val) {
      setTimeout(() => {
        this.search = !this.multiple ? null : this.search
        if (!this.multiple) this.$refs['SelectedTreeview' + this._uid].blur()
      }, 0)
    },

    // Permet au clique sur la croix pour enlever toutes les valeurs de sortir du champs
    clearValue() {
      this.clearValueClick = true
      setTimeout(() => {
        this.$refs['SelectedTreeview' + this._uid].blur()
        this.clearValueClick = false
        this.focused = false
      }, 400)
    },

    // Permet de ne pas pouvoir supprimer une valeur avec le clavier "touche (backspace)" => @keydown.delete
    noBackspace() {
      if (this.treeview) {
        if (!this.multiple) {
          if (this.search == null || this.search == '') {
            var itemOld = [this.active[0]]
            this.active = []
            this.$nextTick(() => {
              this.active = itemOld
            })
          }
        } else {
          if (this.search == null || this.search == '') {
            var itemOld = this.activeItem
            this.activeItem = []
            this.$nextTick(() => {
              this.activeItem = itemOld
            })
          }
        }
      } else {
        if (this.search == null || this.search == '' || this.required) {
          var itemOld = this.listLocal
          this.listLocal = []
          this.$nextTick(() => {
            this.listLocal = itemOld
          })
        }
      }
    },

    // Permet de supprimer une chips
    remove(index, itemID) {
      this.removeValue = true
      if (!this.dropdown && !this.treeview) {
        if (!this.multiple) {
          this.listLocal = []
        } else {
          if (index >= 0) {
            this.listLocal.splice(index, 1)
          }
        }
      } else {
        if (!this.dropdown || (this.dropdown && this.treeview)) {
          if (!this.multiple) {
            this.active = []
          } else {
            this.activeItem.splice(index, 1)
          }
        } else {
          if (!this.multiple) {
            this.listLocal = []
          } else {
            if (index >= 0) {
              this.listLocal.splice(index, 1)
            }
          }
        }
      }
      setTimeout(() => {
        this.removeValue = false
        this.focused = false
      }, 0)

      this.$refs['SelectedTreeview' + this._uid].blur()
    },

    // Fonction qui permet au moment du clique en dehors du composant de lancer une fonction de callBack pour le composant parent
    // Et met a jour updateAfterClose a true
    onClickOutside() {
      if (!this.modal) {
        setTimeout(() => {
          this.search = null
          if (
            this.$refs['SelectedTreeview' + this._uid] &&
            !this.$refs['SelectedTreeview' + this._uid].isMenuActive &&
            !this.updateAfterClose
          ) {
            this.updateAfterClose = true
          }
        }, 0)

        if (this.$refs['SelectedTreeview' + this._uid] && this.$refs['SelectedTreeview' + this._uid].isMenuActive) {
          this.callBack(
            !this.treeview ? this.listLocal : this.isMultiple ? this.activeItem : this.active,
            'click-outside',
            this.mru
          )
        }
      }
    },

    // !! Pour le treeview !!
    // Fonction qui permet au moment de changer une valeur si il y a aucunes valeur selectionner alors on laisser la place au label
    // eventClick = Si on click sur une valeur selectionable seulement
    setLabelNoData(eventClick) {
      this.search = null
      if (eventClick) {
        // Alors on ferme le menu dropdown (treeview)
        this.menuProps = {
          maxHeight: 329,
          closeOnContentClick: !this.isMultiple, // En choix simple uniquement
          // Permet de mettre le menu sous le select
          offsetY: true,
        }
      }
      var itemOld = !this.multiple ? this.active : this.selection
      setTimeout(() => {
        if (this.required) {
          if (!this.multiple) {
            if (itemOld.length > 0 && this.active.length == 0) {
              this.$nextTick(() => {
                this.active = itemOld
              })
            }
          } else {
            if (this.activeItem.length == 0) {
              this.$nextTick(() => {
                this.activeItem = itemOld
              })
            }
          }
        }

        if (this.isMultiple ? this.activeItem.length <= 0 : this.active.length <= 0) {
          this.fakeModel = []
          this.fakeItems = []
        } else {
          this.fakeModel = ['Eudonet']
          this.fakeItems = [
            {
              name: 'Eudonet',
              disabled: true,
            },
          ]
        }

        if (this.selection.length < eventClick.length) {
          eventClick.forEach((item) => {
            if (!item.selected) {
              if (item.id != item.parentId && item.children) {
                item.selected = true
                item.children.forEach((child) => {
                  child.selected = true
                  this.activeItem.push(child)
                })
              } else {
                item.selected = true
              }
            }
          })
        } else if (this.selection.length > eventClick.length) {
          this.selection.forEach((item) => {
            let findItem = eventClick.find((a) => a.id == item.id)
            if (!findItem) {
              item.selected = false
              this.$nextTick(() => {
                let findChild = eventClick.find((a) => a.parentId == item.id)
                if (findChild) {
                  for (var i = 0; i < eventClick.length; i++) {
                    if (eventClick[i].parentId === item.id) {
                      eventClick.splice(i, 1)
                    }
                  }
                  //console.log(indexOfObject, eventClick)

                  //eventClick.splice(indexOfObject, eventClick.length);
                }

                /*
                                eventClick.forEach((item, index) => {
                                    let findItem = eventClick.find(a => a.id == item.parentId)
                                    console.log(item)
                                })
                                */
              })
            }
          })
        }

        function arrayRemove(arr, value) {
          return arr.filter(function (ele) {
            return ele != value
          })
        }

        let selectedCopy = JSON.parse(JSON.stringify(this.activeItem))
        selectedCopy.forEach((item) => {
          if (item.children) {
            item.children.forEach((child) => {
              delete child.selected
            })
            delete item.children
            delete item.selected
          }
        })
        this.callBack(this.isMultiple ? this.activeItem : this.active, 'click-selection', this.mru)
      }, 0)
    },

    // !! Pour le treeview !!
    // Permet au clique sur la croix pour enlever toutes les valeurs de set activeItem (multiple) et active (simple) a vide
    // Ferme le menu et de sort du champs
    clearValueTree() {
      if ((!this.required && !this.dropdown) || (!this.required && this.dropdown && this.treeview)) {
        this.multiple ? (this.activeItem = []) : (this.active = [])
        this.$nextTick(() => {
          this.$refs['SelectedTreeview' + this._uid].isMenuActive = false
          setTimeout(() => {
            this.$refs['SelectedTreeview' + this._uid].blur()
          }, 0)
        })
      }
      this.menuProps = {
        maxHeight: 329,
        closeOnClick: true,
        closeOnContentClick: true,
        offsetY: true,
      }
    },

    // !! Pour le treeview !!
    // Fonction qui permet au moment d'ouvir le menu de passer la data updateAfterClose à false
    getOpen() {
      // A chaque ouverture on dit au menu de ne pas se fermer si on click dedans
      this.menuProps = {
        maxHeight: 329,
        closeOnContentClick: false,
        // Permet de mettre le menu sous le select
        offsetY: true,
      }

      this.updateAfterClose = false
    },

    // !! Pour le treeview !!
    /** Permet de trouver dans le tableau de donnée ($attrs.items), le nom des valeurs déja séléctionnés (this.$attrs.selection)
     * (varArr) Arr
     * (itemID) Object
     */
    getSelectedValues(varArr, itemID) {
      let arr = {}
      for (let c of varArr) {
        if (c.children && c.children.length > 0) {
          let w = this.getSelectedValues(c.children, itemID)
          if (w.id == itemID.id) {
            arr = w
          }
        }
        if (c.id == itemID.id) {
          arr = c
        }
      }
      return arr
    },

    // !! Pour le treeview !!
    /** Permet d'ajouter un attribut "parentId" aux enfants
     * (varArr) Arr
     * (parentId) Object
     */
    setItems(varArr, parentId) {
      let arr = {}
      for (let c of varArr) {
        if (c.children && c.children.length > 0) {
          let w = this.setItems(c.children, c.id)
          c.parentId = parentId
        } else {
          c.parentId = parentId
        }
      }
    },
  },
  mounted() {
    // Si le catalogues est bien là ...
    if (this.$refs['formCatalogue_' + this._uid]) {
      this.$refs['formCatalogue_' + this._uid].validate() // A l'affichage du compostant on vérifie les rules
      this.getLoadItems()

      // !! Pour le treeview !!
      // Si les donnée selectionnées sont vide
      if (this.isMultiple ? this.activeItem.length <= 0 : this.active <= 0) {
        this.fakeModel = []
        this.fakeItems = []
      } else {
        this.fakeModel = ['Eudonet']
        this.fakeItems = [
          {
            name: 'Eudonet',
            disabled: true,
          },
        ]
      }
    }
  },

  computed: {
    // Permet de modifier le texte si une ou plusieurs valeurs sont sélectionées
    getTitleSelections() {
      return this.selected.length < 1
        ? 'Sélectionner une valeur dans la liste'
        : this.selected.length == 1
        ? this.selected.length + ' valeur sélectionnée'
        : this.selected.length + ' valeurs sélectionnées'
    },
    // Permet de filtrer les valeurs dans la liste dans la modale
    itemsModale() {
      const searchComponent = this.searchComponent.toLowerCase()

      if (!searchComponent) return this.items

      return this.items.filter((item) => {
        const text = item.name.toLowerCase()

        return text.indexOf(searchComponent) > -1
      })
    },

    // Ajoute les valeurs sous forme de chips dans la modale
    selections() {
      const selections = []
      for (const selection of this.selected) {
        selections.push(selection)
      }
      return selections
    },

    // Permet de rechercher dans la liste de la modale
    filteredItemsModal() {
      if (this.onlySelection) {
        if (!this.multiple) {
          this.$nextTick(() => {
            if (this.$refs['listItemGroup' + this._uid] && !this.multiple) {
              let valuesSelected = this.listLocal.id
              this.$refs['listItemGroup' + this._uid].internalLazyValue = valuesSelected
            }
          })
          return _.orderBy(
            this.items.filter((item) => {
              return item.id.toString() === this.listLocal.id.toString()
            }),
            'name'
          )
        } else {
          //this.$refs['listItemGroup' + this._uid].internalLazyValue = this.listSelection
          //console.log(this.$refs['listItemGroup' + this._uid].internalLazyValue)

          return _.orderBy(
            this.items.filter((item) => {
              return this.listLocal.find((listItem) => listItem.id.toString() === item.id.toString())
            }),
            'name'
          )
        }
      }

      this.$nextTick(() => {
        if (this.$refs['listItemGroup' + this._uid] && !this.multiple) {
          let valuesSelected = this.listLocal.id
          this.$refs['listItemGroup' + this._uid].internalLazyValue = valuesSelected
        }
      })

      return _.orderBy(
        this.items.filter((item) => {
          return item.name.toLowerCase().match(this.searchModal)
        }),
        'name'
      )
    },

    // Permet de récuperer la liste de sélection
    listSelection: {
      get: function () {
        if (this.multiple && this.modal) {
          let localSelections = []
          this.modalListValue.forEach((item) => {
            localSelections.push(item.id)
          })
          return localSelections
        } else {
          if (this.modal) {
            if (this.listLocal != null) {
              return this.listLocal.id
            }
            return []
          }
        }
      },
      set: function (newVal) {
        if (this.multiple) {
          let diff1 = newVal.filter((val) => !this.localtest.includes(val))
          if (diff1.length > 0) {
            this.localtest.push(diff1[0])
          }
          let diff2 = this.localtest.filter((val) => !newVal.includes(val))
          if (diff2.length > 0) {
            let index = this.localtest.indexOf(diff2[0])
            if (index > -1) {
              if (this.searchModal == this.oldSearchModal) {
                this.localtest.splice(index, 1)
              }
            }
          }

          let localSelections = []
          this.localtest.forEach((id) => {
            localSelections.push(this.items.find((item) => item.id.toString() === id.toString()))
          })
          this.$nextTick(() => {
            this.modalListValue = localSelections
          })
        } else {
          if (newVal) {
            this.modalListValue = this.items.find((item) => item.id.toString() === newVal.toString())
          }
        }
      },
    },

    // Permet d'afficher ou non le bouton "Non renseigné"
    getListButtonClear() {
      return !this.multiple && this.selection != null && this.selection.name
        ? true
        : this.multiple && this.selection != null && this.selection.length > 0
        ? true
        : false
    },

    // Permet de savoir si on peux delete une chips ou pas
    deletableChips() {
      if (this.required) {
        if (!this.dropdown) {
          if (this.multiple) {
            return this.activeItem.length > 1
          } else {
            return this.active.length > 1
          }
        } else {
          if (this.selection) {
            return this.selection.length > 1
          }
        }
      } else {
        return true
      }
    },

    // Permet de copier la selection car on ne peut pas modifier une props directement
    listLocal: {
      get: function () {
        return this.selection
      },
      set: function (value) {
        this.$emit('callBack', value, 'change', this.mru)
      },
    },

    // Return la rules
    getRules() {
      if (this.required) {
        if (this.isMultiple) {
          if (this.dropdown) {
            return [this.selection.length > 0 || this.errorMsg]
          } else {
            return [this.activeItem.length > 0 || this.errorMsg]
          }
        } else {
          if (this.dropdown) {
            return [
              Array.isArray(this.selection)
                ? this.selection.length > 0 || this.errorMsg
                : this.selection != {} || this.errorMsg,
            ]
          } else {
            return [this.active.length > 0 || this.errorMsg]
          }
        }
      }
    },

    // !! Pour le treeview !!
    // Permet d'afficher ou non la croix de suppression de toutes les valeurs
    getClearableTree() {
      if (!this.required) {
        if (!this.dropdown || (this.dropdown && this.treeview)) {
          if (this.multiple) {
            return this.activeItem.length > 0
          } else {
            return this.active.length > 0
          }
        }
      }
    },

    // !! Pour le treeview !!
    // Permet pour la recherche de filtrer les items
    filter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1
    },

    // !! Pour le treeview !!
    // Return les couleurs des chips en fonction du mode dans le quel on est, irisMimic
    getIrisChipColor() {
      if (this.getIrisRdonlyMode) return 'grey lighten-2'
      if (this.getIrisMode) return 'grey lighten-1'
      return ''
    },

    // !! Pour le treeview !!
    // Return la couleur du text des chips en fonction du mode dans le quel on est, irisMimic
    getIrisChipTxtColor() {
      if (this.getIrisRdonlyMode) return 'grey darken-2'
      if (this.getIrisMode) return 'grey darken-3'
      return ''
    },

    // !! Pour le treeview !!
    // Renvoie la/les valeurs sélectionnée(s)
    getItems() {
      return this.isMultiple ? this.activeItem : this.active
    },
  },
  watch: {
    items() {
      this.getLoadItems()
    },
    // Permet au reset la recherche quand on sélectionne une valeurs
    selected() {
      this.searchComponent = ''
    },

    // Permet de set la valeur de recherche old par la nouvelle
    searchModal(val, oldVal) {
      this.oldSearchModal = oldVal
      //console.log(val, oldVal)
    },

    // regarde si la modale s'ouvre ou se ferme
    modal(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs['SelectedTreeview' + this._uid].blur()
          this.$refs['SelectedTreeview' + this._uid].isFocused = false
          this.focused = false
          this.modalListValue = this.listLocal
          let localValues = []
          if (this.multiple) {
            this.listLocal.forEach((item) => {
              localValues.push(item.id)
            })
          } else {
            localValues = this.listLocal.id
            console.log(this.listLocal)
          }
          this.localtest = localValues
        })
      } else {
        this.getCalcHeight()
      }
    },

    // Permet au moment de faire une recherche dans le champs de remettre la liste de tous les items (si on a des mru d'afficher par exemple)
    search(val) {
      if (val != null && this.dropdown) {
        this.datas = this.items
      }
      this.callBack(val, 'search', this.mru)
    },

    // !! Pour le treeview !!
    // Met a jour la props selection au parent si catalogue arbo simple
    active(val) {
      this.$emit('update:selection', val)
    },

    // !! Pour le treeview !!
    // Met a jour la props selection au parent si catalogue arbo multiple
    activeItem(val) {
      this.$emit('update:selection', val)
    },
  },
  created() {
    this.active = !this.multiple ? this.selection : [] // Si catalogue arbo simple alors on copy selection dans le active
    this.activeItem = this.selection // Si catalogue arbo multiple alors on copy selection dans le activeItem
  },
}
</script>

<style>
.right-panel-selections-title {
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 1;
}

.content-right-top > div:last-child {
  border-bottom: 1px solid #e0e0e0 !important;
}

.content-right {
  width: 50%;
}

.list-item-group-multiple.list-item-group-catalogue {
  min-height: 299px;
}

.list-item-group-catalogue {
  min-height: 340px;
}

.content-catalogue {
  display: flex;
  height: calc(100% - 70px);
}

.content-catalogue-list {
  height: calc(100% - 41px);
  border-right: 1px solid #e0e0e0 !important;
  width: 50%;
}

.content-catalogue-list.content-catalogue-list-simple {
  height: 100%;
}

.right-panel-catalogue-modale {
  width: 50%;
}

.list-catalogue-content .item-content {
  flex-flow: row wrap;
  justify-content: space-around;
}

.list-catalogue-content .item-span.item-name {
  flex: 70%;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 0 10px 0px 0px;
}

.list-catalogue-content .item-span {
  flex: 15%;
}

.sticky-list {
  position: sticky;
  z-index: 1;
  background: #fff;
  height: 41px;
}

.sticky-list-top {
  top: 0;
}

.sticky-list-bottom {
  bottom: 0;
  border-bottom: none;
}

.sticky-list-bottom .btn-left,
.sticky-list-bottom .btn-right {
  border-right: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
}

.sticky-list .list-catalogue {
  width: 100%;
  background: #f8f8f8;
  border-bottom: 1px solid #e0e0e0;
}

.search-modal-catalogue {
  width: 50%;
}

.action-btn-modale {
  width: 50%;
  text-align: right;
}

.edn-catalogue-autocomplete .edn-truncated--text {
  display: block;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  float: left;
}

.edn-catalogue-autocomplete label.v-label--active {
  max-width: 123%;
}

.edn-catalogue-autocomplete label.v-label--active.v-label--is-disabled {
  max-width: 119%;
}

.v-treeview + .v-list-item {
  display: none;
}

.v-treeview .v-treeview-node {
  cursor: pointer;
}

.v-treeview-node--click.v-treeview-node--disabled > .v-treeview-node__root,
.v-treeview-node--click.v-treeview-node--disabled > .v-treeview-node__root > .v-treeview-node__content > * {
  cursor: auto;
}

.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: inherit !important;
}

.v-autocomplete .v-label {
  overflow: visible;
}

.v-autocomplete .v-label .v-icon.v-icon {
  top: -2px;
  margin: 0px 0px 0px 3px;
  font-size: 22px;
}

.top-sticked {
  position: sticky;
  top: 0;
  background: #f5f5f5;
  z-index: 1;
}

.bottom-sticked {
  position: sticky;
  bottom: 0;
  background: #f5f5f5;
  z-index: 1;
}

.buttons {
  padding: 0 12px;
}

.filter-item-btn {
  padding: 6px 6px 0;
}

.edn-catalogue-autocomplete .v-list {
  padding: 0 0 0 0;
}

.edn-catalogue-autocomplete .v-select__selections input {
  text-overflow: ellipsis;
}

.item-hidden {
  display: none;
  pointer-events: none;
}

.dropdownOff .v-menu__content {
  display: none !important;
}
.content-row-chips {
  flex-flow: wrap-reverse;
  flex-direction: row-reverse;
  justify-content: start !important;
}
.edn-catalogue-autocomplete .v-select-list {
  overflow: auto;
  max-height: 208px;
}

#bottom-sticked,
#top-sticked {
  display: none;
}

.edn-catalogue-autocomplete #bottom-sticked,
.edn-catalogue-autocomplete #top-sticked {
  display: block;
}
</style>
